import React, { Fragment, useState } from "react";
import { Avatar, Button, Col, Divider, Drawer, Layout, Popover, Row, Upload, Modal, Tooltip } from "antd";
import dummyImg from "../../../assets/image/dummy.png"
import { useNavigate, useLocation } from "react-router-dom";
import {withFreshToken} from "../../../router/sidebarRoute";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    globalBrandConfigState,
    globalBrandModuleSettingState,
    globalNotificationState,
    globalUserDetailState,
} from "../../../_common/global_state";
import { useProfileFunction } from "../../../pages/profile/function";
import useShared from "../../../_common/_shared";
import { useTranslation } from "react-i18next";
import { PlusOutlined, LockFilled, CloseOutlined } from "@ant-design/icons";
import EditNavigationModal_2 from "./editNavigationModal";

const { Sider } = Layout;

export const Sider_2 = ({ routes }) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const location = useLocation()
    const { IconModule } = useShared()
    const { updateProfile } = useProfileFunction()

    const [openEditNavModal, setOpenEditNavModal] = useState(false)
    const [openMorePopover, setIsOpenMorePopOver] = useState(false)
    const [hovered, setHovered] = useState(false);
    const [openDrawers, setOpenDrawers] = useState([]);

    const setNotificationMessage = useSetRecoilState(globalNotificationState)
    const brandConfigState = useRecoilValue(globalBrandConfigState)
    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState)
    const userDetails = useRecoilValue(globalUserDetailState)

    const uploadImage = async (e) => {
        const link = e?.file?.response?.data?.[0]
        if (link) {
            await updateProfile(userDetails?._id, {
                profileImage: link.toString(),
            })
        }
    }

    const categories = [...new Set(routes.flatMap(route => {
        if (route?.sub && !!route?.sub.length && route?.key === "more") {
            return route?.sub.map(subRoute => subRoute?.categoryName);
        }
        return [];
    }))];

    const openDrawer = (drawerKey) => {
        setOpenDrawers(prev => [...prev, drawerKey]);
    };

    const closeDrawer = (drawerKey) => {
        setOpenDrawers(prev => prev.filter(key => key !== drawerKey));
    };

    const handleLockedItemClick = () => {
        Modal.confirm({
            title: t("Access Denied"),
            content: t("Please complete your account verification to access this feature."),
            okText: t("Verify Now"),
            cancelText: t("common.cancel"),
            okButtonProps: { className: "primary_btn", type: "default" },
            cancelButtonProps: { className: "secondary_btn" },
            style: { minWidth: 300 },
            centered: true,
            getContainer: () => document.getElementById("layout-2"),
            onOk: () => navigate("/account-verification"),
        });
    }

    return (
        <Sider width={100} id={"layout-sider"} collapsible breakpoint={"md"} collapsedWidth={"0"}>
            <Col span={24} className={"text-center mt-6 mb-4"}>
                <Upload
                    id={"upload-profile-image"}
                    name={"files"}
                    action={`${brandConfigState?.assetsURL}/api/upload/file`}
                    data={{ brand: brandConfigState?.assetsBrandName, category: "profile" }}
                    showUploadList={false}
                    beforeUpload={(file) => {
                        const isImage = file.type?.includes("image")
                        if (!isImage) {
                            setNotificationMessage({
                                status: "error",
                                title: "",
                                msg: t("errorMsg.type.invalidFileType"),
                                key: "invalidFileType",
                            });
                        }
                        return isImage || Upload.LIST_IGNORE;
                    }}
                    accept={"image/*"}
                    maxCount={1}
                    onChange={uploadImage}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    className={`upload-container ${hovered ? "hovered" : ""}`}
                >
                    <Avatar size={50} src={userDetails?.profileImage || dummyImg} />
                    <div className={"plus-overlay"}><PlusOutlined /></div>
                </Upload>
            </Col>

            {routes?.map((route) => {
                const isRouteLocked = route?.locked;

                if (route?.sub && !!route?.sub?.length) {
                    if (route?.key === "more") {
                        const moreContent = (
                            <div className="more-popover-container">
                                <div className="more-popover-header">
                                    <span className="more-popover-title">⚡ MORE MODULES</span>
                                    <button
                                        className="more-popover-close"
                                        onClick={() => setIsOpenMorePopOver(false)}
                                    >✕</button>
                                </div>

                                <div className="more-popover-modules">
                                    {categories.map((category) => {
                                        const filteredSubs = route?.sub
                                            ?.filter(subRoute => subRoute?.categoryName === category)
                                            ?.sort((a, b) => {
                                                const order = { common: 1, finance: 2, others: 3 };
                                                const cc = order[a.categoryName] - order[b.categoryName];
                                                return cc !== 0 ? cc : order[a.key] - order[b.key];
                                            });

                                        if (!filteredSubs?.length) return null;

                                        return (
                                            <div key={category} className="more-popover-category">
                                                <div className="more-popover-category-header">
                                                    <span className="popover-category-title">{t(`common.${category}`)}</span>
                                                    <div className="more-popover-category-line" />
                                                </div>
                                                <Row className={"layout-sider-popover"}>
                                                    {filteredSubs.map((subRoute, i) => {
                                                        const filterModule = brandModuleSetting?.filter((item) => item?.isEnabled === true && subRoute?.label === item?.name)
                                                        const drawerKey = `${subRoute?.label}`;
                                                        const isDrawerOpen = openDrawers.includes(drawerKey);
                                                        const isSubLocked = subRoute?.locked;

                                                        if (filterModule && subRoute?.sub) return (
                                                            <Fragment key={i}>
                                                                <Col
                                                                    xs={12} lg={6}
                                                                    className={"layout-sider-popover-btn text-center"}
                                                                    style={isSubLocked ? { opacity: 0.5 } : {}}
                                                                    onClick={() => {
                                                                        if (isSubLocked) { handleLockedItemClick(); return; }
                                                                        openDrawer(drawerKey);
                                                                    }}
                                                                >
                                                                    <div className="popover-icon-wrap">
                                                                        {isSubLocked && (
                                                                            <Tooltip title={t("Please complete your account verification to access this feature.")}>
                                                                                <div className="locked-icon-center"><LockFilled /></div>
                                                                            </Tooltip>
                                                                        )}
                                                                        {subRoute?.icon}
                                                                    </div>
                                                                </Col>
                                                                <Drawer
                                                                    key={drawerKey}
                                                                    id={"drawerContainer"}
                                                                    onClose={() => closeDrawer(drawerKey)}
                                                                    open={isDrawerOpen}
                                                                    className={"popoverDrawer"}
                                                                    getContainer={false}
                                                                    width={384}
                                                                    title={
                                                                        <Row justify={"end"}>
                                                                            <Button
                                                                                type={"text"}
                                                                                icon={<CloseOutlined />}
                                                                                onClick={() => closeDrawer(drawerKey)}
                                                                                className={"drawer-close-btn"}
                                                                            />
                                                                        </Row>
                                                                    }
                                                                    closeIcon={false}
                                                                >
                                                                    <Row className={"layout-sider-popover"}>
                                                                        {subRoute?.sub?.map(subSubRoute => {
                                                                            let title = subSubRoute?.label.replace(".", "").replace(/[-\s/+]/g, "_").toLowerCase()
                                                                            const isSubSubActive = subSubRoute?.path && location.pathname.startsWith(subSubRoute?.path);
                                                                            return (
                                                                                <Col
                                                                                    key={subSubRoute?.label}
                                                                                    span={6}
                                                                                    className={`layout-sider-popover-btn text-center${isSubSubActive ? " popover-item-active" : ""}`}
                                                                                    style={subSubRoute?.locked ? { opacity: 0.5 } : {}}
                                                                                    onClick={() => {
                                                                                        if (subSubRoute?.locked) { handleLockedItemClick(); return; }
                                                                                        subSubRoute?.type === "_blank"
                                                                                            ? window.open(withFreshToken(subSubRoute?.path), "_blank")
                                                                                            : navigate(subSubRoute?.path)
                                                                                    }}
                                                                                >
                                                                                    <div className="popover-icon-wrap">
                                                                                        {subSubRoute?.locked && (
                                                                                            <Tooltip title={t("Please complete your account verification to access this feature.")}>
                                                                                                <div className="locked-icon-center"><LockFilled /></div>
                                                                                            </Tooltip>
                                                                                        )}
                                                                                        <IconModule
                                                                                            iconName={subSubRoute?.label}
                                                                                            className={"sidebarIcon"}
                                                                                            title={title}
                                                                                            isAlwaysActive={isSubSubActive}
                                                                                        />
                                                                                    </div>
                                                                                </Col>
                                                                            )
                                                                        })}
                                                                    </Row>
                                                                </Drawer>
                                                            </Fragment>
                                                        )

                                                        const isSubActive = subRoute?.path && location.pathname.startsWith(subRoute.path);
                                                        return (
                                                            <Col
                                                                key={i}
                                                                xs={12} lg={6}
                                                                className={`layout-sider-popover-btn text-center${isSubActive ? " popover-item-active" : ""}`}
                                                                style={isSubLocked ? { opacity: 0.5 } : {}}
                                                                onClick={() => {
                                                                    if (isSubLocked) { handleLockedItemClick(); return; }
                                                                    subRoute?.type === "_blank" ? window.open(withFreshToken(subRoute?.path), "_blank") : navigate(subRoute?.path)
                                                                    setIsOpenMorePopOver(false)
                                                                }}
                                                            >
                                                                <div className="popover-icon-wrap">
                                                                    {isSubLocked && (
                                                                        <Tooltip title={t("Please complete your account verification to access this feature.")}>
                                                                            <div className="locked-icon-center"><LockFilled /></div>
                                                                        </Tooltip>
                                                                    )}
                                                                    {subRoute?.icon}
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            </div>
                                        );
                                    })}
                                </div>

                                <Col span={24} className={"text-center editNavigation"}>
                                    {/*<Divider style={{ margin: "0.2rem 0", background: "var(--divider-color)" }} />*/}
                                    <Button
                                        type={"link"}
                                        onClick={() => {
                                            setOpenEditNavModal(true);
                                            setIsOpenMorePopOver(false);
                                        }}
                                    >
                                        {t("common.editNavigation")}
                                    </Button>
                                </Col>
                            </div>
                        );

                        return (
                            <Popover
                                key={route?.key}
                                open={openMorePopover}
                                destroyTooltipOnHide
                                className={"setPopoverCustom"}
                                content={moreContent}
                                getPopupContainer={triggerNode => triggerNode.parentElement}
                                placement={"right"}
                                trigger="hover"
                                mouseEnterDelay={0.15}
                                mouseLeaveDelay={0.15}
                                onOpenChange={(bool) => setIsOpenMorePopOver(bool)}
                            >
                                <Col
                                    span={24}
                                    className={`text-center cursor-pointer${openMorePopover ? " more-popover-active" : ""}`}
                                >
                                    {route?.icon}
                                </Col>
                            </Popover>
                        )
                    }

                    const content = (
                        // the popover shrinks to its content, so the 25% columns need a set width (the More panel's 95px tiles)
                        <Row className={"layout-sider-popover"} style={{width: Math.min(route?.sub?.length, 4) * 95}}>
                            {route?.sub?.map(subRoute => (
                                <Col
                                    key={subRoute?.label}
                                    xs={12}
                                    lg={6}
                                    className={`layout-sider-popover-btn text-center ${route?.sub?.length > 4 ? "mt-1 align-ce" : "mb-0"}`}
                                    style={subRoute?.locked ? { opacity: 0.5 } : {}}
                                    onClick={() => {
                                        if (subRoute?.locked) { handleLockedItemClick(); return; }
                                        subRoute?.type === "_blank" ? window.open(withFreshToken(subRoute?.path), "_blank") : navigate(subRoute?.path)
                                    }}
                                >
                                    <div className="popover-icon-wrap">
                                        {subRoute?.locked && (
                                            <Tooltip title={t("Please complete your account verification to access this feature.")}>
                                                <div className="locked-icon-center"><LockFilled /></div>
                                            </Tooltip>
                                        )}
                                        {subRoute?.icon}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    );

                    return (
                        <Popover
                            key={route?.key}
                            destroyTooltipOnHide
                            content={content}
                            placement={"right"}
                            getPopupContainer={triggerNode => triggerNode.parentElement}
                        >
                            <Col span={24} className={"text-center cursor-pointer"}>
                                {route?.icon}
                            </Col>
                        </Popover>
                    )
                }

                return (
                    <Col
                        span={24}
                        className={`text-center mb-4 cursor-pointer${route?.path && location.pathname.startsWith(route?.path) ? " sider-item-active" : ""}`}
                        key={route?.label}
                        style={isRouteLocked ? { opacity: 0.5 } : {}}
                        onClick={() => {
                            if (isRouteLocked) { handleLockedItemClick(); return; }
                            route?.type === "_blank" ? window.open(withFreshToken(route?.path), "_blank") : navigate(route?.path)
                        }}
                    >
                        <div className="popover-icon-wrap">
                            {isRouteLocked && (
                                <Tooltip title={t("Please complete your account verification to access this feature.")}>
                                    <div className="locked-icon-center"><LockFilled /></div>
                                </Tooltip>
                            )}
                            {route?.icon}
                        </div>
                    </Col>
                )
            })}
            <EditNavigationModal_2 isModalOpen={openEditNavModal} handleCancel={() => setOpenEditNavModal(false)} />
        </Sider>
    )
}
